var AuthConstants;
(function (AuthConstants) {
    AuthConstants["GET_TOKENS"] = "GET_TOKENS";
    AuthConstants["GET_TOKENS_SUCCESS"] = "GET_TOKENS_SUCCESS";
    AuthConstants["GET_TOKENS_FAILURE"] = "GET_TOKENS_FAILURE";
    AuthConstants["CLEAR_TOKENS"] = "CLEAR_TOKENS";
    AuthConstants["RENEW_ACCESS_TOKEN"] = "RENEW_ACCESS_TOKEN";
    AuthConstants["RENEW_ACCESS_TOKEN_SUCCESS"] = "RENEW_ACCESS_TOKEN_SUCCESS";
    AuthConstants["RENEW_ACCESS_TOKEN_FAILURE"] = "RENEW_ACCESS_TOKEN_FAILURE";
    AuthConstants["SET_USER_SESSION_EXPIRED"] = "SET_USER_SESSION_EXPIRED";
    AuthConstants["LOGOUT_USER"] = "LOGOUT_USER";
    AuthConstants["LOGOUT_USER_SUCCESS"] = "LOGOUT_USER_SUCCESS";
    AuthConstants["LOGOUT_USER_FAILURE"] = "LOGOUT_USER_FAILURE";
    AuthConstants["SIGN_IN_FAILURE"] = "SIGN_IN_FAILURE";
    AuthConstants[AuthConstants["REFRESH_TOKEN_RETRY_DELAY_MILLIS"] = 3000] = "REFRESH_TOKEN_RETRY_DELAY_MILLIS";
    AuthConstants["SET_USER_SESSION_ABOUT_TO_EXPIRE"] = "SET_USER_SESSION_ABOUT_TO_EXPIRE";
    AuthConstants[AuthConstants["INTERVAL_TIMEOUT_SECS"] = 2147483.647] = "INTERVAL_TIMEOUT_SECS";
    AuthConstants[AuthConstants["REFRESH_TOKEN_API_MAX_RETRY_COUNT"] = 1] = "REFRESH_TOKEN_API_MAX_RETRY_COUNT";
    AuthConstants["GET_GOOGLE_SPOT_TOKENS"] = "GET_GOOGLE_SPOT_TOKENS";
    AuthConstants["GET_GOOGLE_SPOT_TOKENS_SUCCESS"] = "GET_GOOGLE_SPOT_TOKENS_SUCCESS";
    AuthConstants["GET_GOOGLE_SPOT_TOKENS_FAILURE"] = "GET_GOOGLE_SPOT_TOKENS_FAILURE";
    AuthConstants[AuthConstants["REFRESH_TOKEN_EXPIRING_IN_DEFAULT_SECS"] = 300] = "REFRESH_TOKEN_EXPIRING_IN_DEFAULT_SECS";
    AuthConstants[AuthConstants["CHECK_ACCESS_TOKEN_INTERVAL_DEFAULT_MILLIS"] = 100] = "CHECK_ACCESS_TOKEN_INTERVAL_DEFAULT_MILLIS";
})(AuthConstants || (AuthConstants = {}));
export default AuthConstants;
